import _ from 'lodash'
import React, { Component } from 'react'
import autoBind from 'react-autobind'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Link } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { Button, Container, Form, Grid, Image, Segment } from 'semantic-ui-react'

import check from '../../assets/images/check.png'
import logo from '../../assets/images/logo.png'
import { resetPassword } from '../../helpers/auth'
import { tr } from '../../helpers/languages'
import { actions as messages } from '../../store/actions/messages'

class ForgotPassword extends Component {
    constructor (props) {
        super(props)
        this.state = {
            email: '',
            errors: {},
            done: false,
            doNotDisturb: false
        }
        autoBind(this)
    }

    // Changes the value of some field.
    changeValue (field, value) {
        this.setState({ [field]: value })
    }

    // Requests for a password reset.
    requestPasswordReset () {
        // Do not disturb.
        if (this.state.doNotDisturb) {
            return
        }

        // Put the do not disturb sign, and clear all errors.
        this.setState({ doNotDisturb: true, errors: {} })

        // Validate.
        let errors = {}

        // The email is required.
        if (_.isEmpty(this.state.email)) {
            errors = { ...errors, email: tr('EMAIL_REQUIRED') }
        }

        // There are errors. Break.
        if (!_.isEmpty(errors)) {
            this.setState({ doNotDisturb: false, errors })
            return
        }

        // Reset a password request.
        return resetPassword({
            email: this.state.email
        })
            .then(() => {
                this.setState({ doNotDisturb: false, done: true })
            })
            .catch((error) => {
                // Failed to request a password reset.
                // eslint-disable-next-line no-console
                console.error('Failed to request password reset.', error)
                this.props.message({ type: 'error', text: tr('FAILED_TO_REQUESET_PASSWORD_RESET') })
                this.setState({ doNotDisturb: false })
            })
    }

    // Goes to the given location.
    goTo (location) {
        this.props.history.push(location)
    }

    render () {
        return (
            <Container className='forgot-password'>
                <Link to='/'>
                    <Image className='logo' src={logo} centered/>
                </Link>
                <Grid className='segment centered'>
                    {
                        !this.state.done && (
                            <Form>
                                <Segment className='instructions'>{tr('COMPLETE_EMAIL_TO_SEND_RESET_LINK')}</Segment>
                                <Form.Input
                                    name='email'
                                    type='text'
                                    value={this.state.email}
                                    placeholder={tr('EMAIL')}
                                    error={!_.isEmpty(this.state.errors) && !_.isEmpty(this.state.errors.email)}
                                    onChange={(e) => { this.changeValue(e.target.name, e.target.value) }}
                                />
                                {
                                    !_.isEmpty(this.state.errors) && !_.isEmpty(this.state.errors.email) && (
                                        <div className='error-message'>{this.state.errors.email}</div>
                                    )
                                }
                                <Form.Button
                                    type='submit'
                                    className={this.state.doNotDisturb ? 'do-not-disturb' : ''}
                                    onClick={(_e) => { this.requestPasswordReset() }}
                                >
                                    {tr('SEND')}
                                </Form.Button>
                            </Form>
                        )
                    }
                    {
                        this.state.done && (
                            <Container className='password-forgotten'>
                                <Segment className='check'>
                                    <span className='border'><Image src={check}/></span>
                                </Segment>
                                <Segment className='note'>{tr('WE_HAVE_SENT_YOU_A_PASSWORD_RESET_EMAIL')}</Segment>
                                <Segment>
                                    <Button
                                        className='back'
                                        onClick={(_e) => { this.goTo('/') }}
                                    >
                                        {tr('BACK_TO_LOGIN')}
                                    </Button>
                                </Segment>
                            </Container>
                        )
                    }
                </Grid>
            </Container>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        language: state.settings.language
    }
}

const mapDispatchToProps = (dispatch) => {
    const _messages = bindActionCreators(messages, dispatch)
    return {
        message: _messages.message
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ForgotPassword))



// WEBPACK FOOTER //
// ./src/components/forgot-password/index.js